export default __webpack_public_path__ + "static/media/responsivex3.62de01b1.png";